export * from "../textChanges.js";